module.exports = __webpack_public_path__ + "img/call.b2770066.svg";